const config = {
    apiEndpoint: process.env.REACT_APP_API_HOST,
    apiKey: process.env.REACT_APP_API_KEY,
    publicPageEndpoint: process.env.REACT_APP_STANDINGS_PAGE_HOST,
    idTournamentSeason: 'D51C54DE-9424-49AC-AF3A-B7E57E2BC9A9',
    wildcard: 'abc123',
    palette: {
        green: '#2cad3c',
        blue: '#008db5',
        yellow: '#fdee21',
        purple: '#a713a2'
    },
    seasonColors: {
        Recreational: '#259bd9',
        Competitive: '#a713a2',
        Tournament: '#4fb03c',
        Camp: '#fd930c'
    },
    bgs: ['bg-pic-1', 'bg-pic-2', 'bg-pic-3', 'bg-pic-4', 'bg-pic-5', 'bg-pic-6', 'bg-pic-7', 'bg-pic-8', 'bg-pic-9', 'bg-pic-10', 'bg-pic-11', 'bg-pic-12', 'bg-pic-13'],
    seasonTypes: [
        {
            Id: 1,
            Name: 'Recreational'
        },
        {
            Id: 2,
            Name: 'Competitive'
        },
        {
            Id: 3,
            Name: 'Tournament'
        },
        {
            Id: 4,
            Name: 'Camp'
        }
    ],
    tournamentPointsSystemTypes: [
        {
            Id: 1,
            Name: 'Cooper'
        },
        {
            Id: 2,
            Name: 'Silver'
        },
        {
            Id: 3,
            Name: 'Gold'
        }
    ],
    clothingSizes: [
        'Youth Small',
        'Youth Medium',
        'Youth Large',
        'Youth XL',
        'Small',
        'Medium',
        'Large',
        'X-Large',
        'XX-Large',
    ],
    divisionStatuses: [
        { IdRoleStatus: 1, RoleStatusName: 'Open' },
        { IdRoleStatus: 2, RoleStatusName: 'Closed' },
        { IdRoleStatus: 3, RoleStatusName: 'Waitlist' },
        { IdRoleStatus: 4, RoleStatusName: 'Tryout' },
    ],
    roleStatuses: [
        {
            IdRoleStatus: 1,
            RoleStatusName: "Pending",
            color: '#008db5'
        },
        {
            IdRoleStatus: 2,
            RoleStatusName: "Active",
            color: '#2cad3c'
        },
        {
            IdRoleStatus: 3,
            RoleStatusName: "Denied",
            color: '#dc3545'
        },
        {
            IdRoleStatus: 4,
            RoleStatusName: "Waiting",
            color: '#fdee21'
        },
        {
            IdRoleStatus: 5,
            RoleStatusName: "Inactive",
            color: '#dc3545'
        },
        {
            IdRoleStatus: 6,
            RoleStatusName: "Tryout",
            color: '#a713a2'
        }
    ],
    tieBreakers: [{
        label: 'Head to Head',
        value: 1
    }, {
        label: 'Goal Differential',
        value: 2
    }, {
        label: 'Goals For',
        value: 3
    }, {
        label: 'Goals Against',
        value: 4
    }, {
        label: 'Wins Percent',
        value: 5
    }],
    capActions: [
        {
            IdCapAction: 0,
            Name: 'Nothing'
        },
        {
            IdCapAction: 1,
            Name: 'Close and waitlist when reaches cap'
        },
        {
            IdCapAction: 2,
            Name: 'Close when reaches cap'
        },
    ],
    genders: [
        {
            IdGender: 1,
            Name: 'Male'
        },
        {
            IdGender: 2,
            Name: 'Female'
        },
        {
            IdGender: 3,
            Name: 'COED'
        }
    ],
    realGenders: [
        {
            IdGender: 1,
            Name: 'Male'
        },
        {
            IdGender: 2,
            Name: 'Female'
        },
    ]
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js